"use client";

import { ReactNode, memo } from "react";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";

const AlertModal = memo(
  ({
    isOpen,
    title,
    message,
    onClose,
  }: {
    isOpen: boolean;
    title: string;
    message: ReactNode;
    onClose: () => void;
  }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="mx-14 mb-5 mt-10 flex flex-col items-center">
          <p className="mb-4 text-center text-[20px]">{title}</p>
          <p className="mb-12 text-center text-[16px]">{message}</p>
          <Button text="閉じる" onClick={onClose} style={ButtonStyle.OUTLINE} width="w-[160px]" />
        </div>
      </Modal>
    );
  }
);

AlertModal.displayName = "AlertModal";

export default AlertModal;
